import axios from 'axios';
import Vue from 'vue';
import store from '@/store';
import { Message, MessageBox } from 'element-ui';
import { getToken } from '@/utils/token';
import { getUserAndToken, isHttps, copyToClipboard } from '@/utils/utils';
import { getSsoAuthUrlApi } from '@/api/newLogin/index';
import Cookies from 'js-cookie';
import qs from 'qs';
import _ from 'lodash';
import router from '@/router';
import { ClarityHelper } from '@/api/clarityHelper/index.js';

// 存储失败的请求
let failedRequests = [];

const errorNetwork = _.throttle(() => {
  Message({
    message: '网络有问题,请检查网络是否正常',
    type: 'error',
    duration: 5 * 1000,
  });
}, 5000);

// axios.defaults.headers.common['X-Requested-With'] = "XMLHttpRequest";
// axios.defaults.headers.common['x-fbads-account'] = ''
axios.defaults.headers['Content-Type'] = 'application/json';
let baseURL = process.env.VUE_APP_GATEWAY_GADS2;
let alertTime = '';
let timeout = 20000;
let _isHttps = isHttps();

let singeOpenUrl = '';
async function goSsoAuthUrl() {
  const params = {
    clientLoginUrl: localStorage.getItem('loginUrl') || '',
    back: localStorage.getItem('loginUrl') || '',
  };
  try {
    const res = await getSsoAuthUrlApi(params);
    singeOpenUrl = res.data;
    return res.data;
  } catch (error) {
    console.warn(error);
  }
}
export function operate401() {
  // 阻止重复弹出,记录上次弹框时间
  let curTime = new Date().getTime();
  if (alertTime && curTime - alertTime < 6000) {
    return false;
  } else {
    alertTime = curTime;
  }
  MessageBox.confirm('确认重新登录吗?', '重新登录确认', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning',
    showClose: false,
    closeOnClickModal: false,
  })
    .then(async () => {
      Cookies.remove('token');
      try {
        const res = await goSsoAuthUrl();
        // singeOpenUrl = res;
        if (res) {
          handleAuth(res);
        }
        // handleAuth();
      } catch (e) {
        console.error('获取SSO地址失败:', e);
      }
      //   let left = (window.screen.width - 500) / 2,
      //     top = (window.screen.height - 500) / 2;
      //   window.open(`${process.env.VUE_APP_DOMAIN}/#/ad/loginBack`, '', `width=900,height=600,left=${left},top=${top}`);
      //   //   window.open('/api/login/relogin', '', `width=500,height=500,left=${left},top=${top}`);
    })
    .catch(() => {
      Message({
        type: 'info',
        message: '已取消重新登录！',
      });
    });
}

export function accountAbnormal() {
  MessageBox.confirm(`当前的广告帐号不可用，请切换帐号后重试！`, '更换帐号', {
    confirmButtonText: '确认',
    cancelButtonText: '取消',
    type: 'warning',
  })
    .then(() => {
      Message({
        message: '请前往账号列表或广告资产页面切换帐号！',
        type: 'info',
      });
    })
    .catch(() => {
      Message({
        message: '已取消更换帐号！',
        type: 'info',
      });
    });
}
export const BASEURL = baseURL;
// create an axios instance
const service = axios.create({
  baseURL: baseURL, //
  withCredentials: false, // send cookies when cross-domain requests
  timeout: timeout, // request timeout
  transformRequest: [
    function (data) {
      // let ret = '';
      // for (let it in data) {
      //   ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
      // }
      // return ret
      return qs.stringify(data);
    },
  ],
});

// request interceptor
service.interceptors.request.use(
  (config) => {
    if (!config.headers['thirdLoginUserId'] && !config.notThirdLoginUserId) {
      let id = store.state.num.selectedNum ? store.state.num.selectedNum : null;
      config.headers['thirdLoginUserId'] = id;
    }
    // if(!config.headers['token']&&store.state.user.userInfo.data){
    //   config.headers['token'] = store.state.user.userInfo.data.token;
    // }
    if (!config.headers['adAccountId'] && !config.notThirdLoginUserId) {
      let adAccountId = null;
      if (config.params) {
        adAccountId = config.params.accountId || config.params.account_id || config.params.adAccountId;
      }
      if (!adAccountId && config.data) {
        const _data = typeof config.data === 'string' ? JSON.parse(config.data) : config.data;
        adAccountId = _data.account_id || _data.accountId || _data.adAccountId;
      }
      if (adAccountId) {
        config.headers['adAccountId'] = adAccountId;
      } else if (store.getters.accountId) {
        config.headers['adAccountId'] = store.getters.accountId;
      }
    }
    // 头部添加币种、账户名称
    let currency = store.getters.currentAccountInfo?.currency;
    let accountName = store.getters.currentAccountInfo?.name;
    config.headers['currencyCode'] = currency?.key || null;
    config.headers['adAccountName'] = encodeURIComponent(accountName) || null;

    //多账户管理页面都不传个号
    if (router.currentRoute.fullPath == '/ad/multiAccountManageIndex') {
      delete config.headers.thirdLoginUserId;
    }
    // let token = getToken(); //Cookies.get('token'); //'179b007ec9edd5608245acc7611e1165';
    // if (token && !config.notNeedToken) {
    //   config.headers['token'] = token;
    // } else {
    // }
    const saToken = localStorage.getItem('saToken') || '';
    if (saToken && !config.notNeedToken) {
      config.headers['saToken'] = saToken;
      // config.headers['token'] = saToken;
      // config.headers['token'] = '014dd295c72db80123923d6d1db39962';
    }
    // config.headers['cookie'] = '';
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);
// response interceptor
service.interceptors.response.use(
  (response) => {
    let res = response.data;
    // 网关偶发把已序列化的响应体再包一层 JSON 字符串(同一接口间歇性返回字符串而非对象),
    // 在响应边界统一还原为对象,避免下游 res.code/res.data 读取失败;
    // 仅作用于字符串形态响应,对象形态响应行为完全不变
    if (typeof res === 'string') {
      try {
        const parsed = JSON.parse(res);
        if (parsed && typeof parsed === 'object') res = parsed;
      } catch (e) {
        // 非 JSON 字符串(如 HTML 错误页)保持原样
      }
    }
    // 后端/网关偶发对同一接口返回未统一包装的响应(如 {comment:"success", data:...} 缺少 code),
    // 在切换账户等场景下更易复现(myColumns 等接口);在响应边界推断 code,
    // 避免下游 res.code != 0 判断把成功响应误判为业务错误
    if (res && typeof res === 'object' && !Array.isArray(res) && !('code' in res)) {
      const isSuccessShape = (res.comment === 'success' || res.comment === 'ok') && Object.prototype.hasOwnProperty.call(res, 'data');
      res.code = isSuccessShape ? 0 : -1;
    }
    if (res.code == '401' || res.code == 401 || response.status == 401) {
      return new Promise((resolve, reject) => {
        failedRequests.push({ originalConfig: response.config._originalConfig || response.config, resolve, reject });
        operate401();
      });
    } else if (res.code != 0 && res.code != 200 && res.code != 11) {
      if (res.code == '2001815694') {
        accountAbnormal();
      } else {
        if (!response.config.hideErrorMessage) {
          copyToClipboard(`${res.comment || 'Error'} 。唯一ID: ${res.request_id}`);
        }
      }
      ClarityHelper.trackEvent('fb_接口异常_业务错误', {
        url: response.config.url,
        userId: store.state.user.userInfo.id,
        userName: store.state.user.userInfo.name,
        status: response ? response.status : 'network_error', // 显
        code: res.code,
        msg: res.comment || res.message || '未知业务错误',
        method: response.config.method,
        requestId: res.request_id,
      });
    }
    return res;
  },
  (error) => {
    Vue.prototype.$hideLoading();
    if (error == 'Cancel') {
      return Promise.reject(error);
    }
    if (error.response && (error.response.status == '401' || error.response.status == 401)) {
      return new Promise((resolve, reject) => {
        failedRequests.push({
          originalConfig: error.response.config._originalConfig || error.response.config,
          resolve,
          reject,
        });
        operate401();
      });
    } else {
      const silentTransport = error.config && error.config.hideTransportError;
      if (error.response && error.response.status == '2001815694') {
        accountAbnormal();
      } else if (!silentTransport) {
        if (error == 'Error: Network Error' || error == 'Network Error') {
          errorNetwork();
        } else {
          Message({
            message: error.message == 'timeout of 20000ms exceeded' ? '操作超时!' : error.message,
            type: 'error',
            duration: 5 * 1000,
          });
        }
      }
    }
    const { response, config } = error;
    ClarityHelper.trackEvent('fb_接口异常_系统错误', {
      url: config ? config.url : 'unknown',
      status: response ? response.status : 'network_error',
      msg: error.message,
      method: config ? config.method : 'unknown',
    });
    if (error.response) {
      window.Smartlook &&
        window.Smartlook.error({
          message: error.response,
          type: '接口错误',
        });
    }
    return Promise.reject(error);
  },
);

// 从 URL 中提取 ticket 参数（兼容 hash 和 search 两种格式）
function getTicketFromUrl(href) {
  // 优先从 hash 中提取（如 /#/?back=...&ticket=xxx）
  const hashMatch = href.match(/[#?&]ticket=([^&]+)/);
  if (hashMatch) {
    return hashMatch[1];
  }
  // 兜底：从 search 中提取
  try {
    const url = new URL(href);
    return url.searchParams.get('ticket');
  } catch (e) {
    return null;
  }
}

// 授权处理函数
function handleAuth(ssoUrl) {
  let left = (window.screen.width - 500) / 2,
    top = (window.screen.height - 500) / 2;
  const popup = window.open(ssoUrl, '', `width=900,height=600,left=${left},top=${top}`);

  const checkAuth = setInterval(() => {
    try {
      if (popup.closed) {
        clearInterval(checkAuth);
        MessageBox.close();
        return;
      }

      // 检查URL是否包含ticket参数
      if (popup.location.href.includes('ticket=')) {
        const ticket = getTicketFromUrl(popup.location.href);
        clearInterval(checkAuth);
        popup.close();
        MessageBox.close();
        if (ticket) {
          // 调用doLoginByTicket获取saToken
          handleTicketLogin(ticket);
        } else {
          console.error('无法从URL中提取ticket');
          operate401();
        }
      }
    } catch (e) {
      // 跨域时检查URL是否变为本地地址
      try {
        if (popup.location.hostname === '192.168.1.179') {
          clearInterval(checkAuth);
          popup.close();
          MessageBox.close();
          // 授权完成，重新调用失败的请求
          retryFailedRequests();
        }
      } catch (e2) {
        // 继续检查
      }
    }
  }, 500);
}

// 处理ticket登录
async function handleTicketLogin(ticket) {
  try {
    const { doLoginByTicketApi } = await import('@/api/newLogin/index');
    const res = await doLoginByTicketApi(ticket);
    const saToken = res && res.data ? res.data : '';

    if (saToken) {
      localStorage.setItem('saToken', saToken);
      // 登录成功，重试失败的请求
      retryFailedRequests();
    } else {
      // 没有saToken，重新按401处理
      operate401();
    }
  } catch (error) {
    console.error('Ticket login failed:', error);
    // ticket接口失败，重新按401处理
    operate401();
  }
}

// 重试失败的请求
function retryFailedRequests() {
  const requests = [...failedRequests];
  failedRequests = [];

  requests.forEach(({ originalConfig, resolve, reject }) => {
    service.request(originalConfig).then(resolve).catch(reject);
  });
}

export default service;
